const mentorTasks = [
  'Встречает новичка в первый день, показывает офис и знакомит с командой',
  'Обучает рабочим процессам, продуктам и стандартам компании',
  'Отвечает на вопросы — без оценки «глупый или нет»',
  'Демонстрирует правильное выполнение задач на своём примере',
  'Даёт обратную связь после выполнения новичком первых задач',
  'Поддерживает морально: адаптация — стресс, наставник снижает тревожность',
  'Передаёт неформальные знания: «как у нас принято» и «что реально важно»',
  'Контролирует заполнение чек-листов и соблюдение плана адаптации',
  'Сообщает руководителю о проблемах, если видит риск увольнения',
  'Остаётся на связи после окончания активной фазы — как старший коллега',
];

const criteria = [
  'Опыт работы в компании от 1 года',
  'Высокие результаты на своей позиции',
  'Желание и способность обучать других',
  'Лояльность компании и понимание корпоративной культуры',
  'Терпение и эмпатия — без этого наставничество превращается в мучение',
  'Коммуникабельность и умение объяснять сложное простыми словами',
];

const mentorMistakes = [
  '«Делай как я» без объяснения логики',
  'Игнорирование вопросов новичка из-за своей загрузки',
  'Критика вместо конструктивной обратной связи',
  'Перегруз новичка задачами без учёта этапа адаптации',
  'Отсутствие контакта — наставник «назначен», но не общается',
];

export default function MentorRole() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Роль наставника в адаптации новых сотрудников
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Наставник сокращает время выхода на KPI в 1,5-2 раза. Без наставника система адаптации не работает — это не опция, а обязательный элемент онбординга.
        </p>

        <div className="grid lg:grid-cols-2 gap-8 mb-12">
          <div className="bg-white rounded-xl p-6 md:p-8 border border-gray-200">
            <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
              <i className="ri-user-heart-line text-teal-600"></i> Что делает наставник
            </h3>
            <ul className="space-y-3">
              {mentorTasks.map((task, i) => (
                <li key={i} className="flex items-start gap-2 text-gray-700">
                  <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span className="text-sm leading-relaxed">{task}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-6">
            <div className="bg-white rounded-xl p-6 md:p-8 border border-gray-200">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                <i className="ri-search-eye-line text-teal-600"></i> Как выбрать наставника
              </h3>
              <ul className="space-y-2">
                {criteria.map((c, i) => (
                  <li key={i} className="flex items-start gap-2 text-gray-700">
                    <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                    <span className="text-sm leading-relaxed">{c}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-white rounded-xl p-6 md:p-8 border border-red-200">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                <i className="ri-error-warning-line text-red-500"></i> Типичные ошибки наставников
              </h3>
              <ul className="space-y-2">
                {mentorMistakes.map((m, i) => (
                  <li key={i} className="flex items-start gap-2 text-gray-700">
                    <i className="ri-close-circle-line text-red-400 mt-0.5 flex-shrink-0"></i>
                    <span className="text-sm leading-relaxed">{m}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="bg-teal-50 rounded-xl p-6 md:p-8 border border-teal-200 text-center">
          <h3 className="text-xl font-bold text-gray-900 mb-3">Как оценивать работу наставника</h3>
          <p className="text-gray-700 leading-relaxed max-w-2xl mx-auto">
            Скорость выхода новичка на KPI, результаты промежуточной и финальной оценки сотрудника, 
            обратная связь от новичка о качестве наставничества и процент успешно прошедших испытательный срок — 
            четыре объективных показателя эффективности наставника.
          </p>
        </div>
      </div>
    </section>
  );
}